var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quote",style:(_vm.backgroundStyles)},[_c('blockquote',{staticClass:"quote__quote",domProps:{"innerHTML":_vm._s(_vm.quoteText)},on:{"click":_vm.handleLinkClick}})])}
var staticRenderFns = []

export { render, staticRenderFns }